import {
    autocompleteCanonicalAddress,
    autocompleteFullAddress,
    clearUnresolvedAutocompleteLatLngPatch,
    isResolvedAutocompleteAddress,
} from '@/utilities/address';

const compactObject = (obj) => Object.fromEntries(Object.entries(obj).filter(([, value]) => value !== undefined));
export const isReviewGeocodingStatus = (status) => status === 'PARTIAL';

export const clearGeocodingLeg = (geocoding, leg) => {
    const next = { ...(geocoding || {}) };
    delete next[leg];
    return next;
};

export const formatGeocodingSuggestion = (suggestion = {}) => {
    return (
        suggestion.full_address ||
        suggestion.address ||
        [suggestion.street, suggestion.city, suggestion.state, suggestion.zip].filter(Boolean).join(', ')
    );
};

export const geocodingSuggestionCoords = (suggestion = {}) => {
    return suggestion?.lat != null && suggestion?.lng != null ? { lat: suggestion.lat, lng: suggestion.lng } : null;
};

export const isApproximateGeocodingSuggestion = (suggestion = {}) => {
    return ['APPROXIMATE', 'GEOMETRIC_CENTER'].includes(suggestion.location_type);
};

export const hasReviewGeocodingSuggestion = (geocoding, leg) => {
    const suggestion = geocoding?.[leg]?.suggestion;
    return !!(isReviewGeocodingStatus(geocoding?.[leg]?.status) && suggestion?.lat != null && suggestion?.lng != null);
};

export const geocodingFromAutocomplete = (geocoding, leg, value, split) => {
    const next = clearGeocodingLeg(geocoding, leg);
    if (isResolvedAutocompleteAddress(split) || split?.lat == null || split?.lng == null) {
        return next;
    }

    next[leg] = {
        status: 'PARTIAL',
        source: 'autocomplete',
        suggestion: compactObject({
            address: split.address,
            full_address: autocompleteFullAddress(value, split),
            street: split.street || split.addressLine,
            city: split.city,
            state: split.state,
            zip: split.zip,
            lat: split.lat,
            lng: split.lng,
            location_type: split.locationType || 'GEOMETRIC_CENTER',
        }),
        diagnostics: {
            reason_codes: ['AUTOCOMPLETE_PARTIAL'],
        },
    };
    return next;
};

export const autocompleteAddressPatch = ({ attrs, geocoding, leg, value, split }) => ({
    [attrs.geocode_failed]: false,
    [attrs.address]: autocompleteCanonicalAddress(value, split),
    [attrs.street]: split.street,
    [attrs.city]: split.city,
    [attrs.state]: split.state,
    [attrs.zip]: split.zip,
    ...clearUnresolvedAutocompleteLatLngPatch(split, attrs.lat, attrs.long),
    auto_assign_failed: false,
    geocoding: geocodingFromAutocomplete(geocoding, leg, value, split),
});
